/** @format */

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const ModelConfirm = ({
  params = null,
  open,
  title,
  message,
  labelButton,
  handleClose,
  handleAgree,
  disableBtn = false,
  disableBtnAgree = false
}) => (
  <>
    <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={disableBtn}>
          Huỷ bỏ
        </Button>
        <Button onClick={() => handleAgree(params)} autoFocus variant="contained" disabled={disableBtnAgree || disableBtn}>
          {labelButton}
        </Button>
      </DialogActions>
    </Dialog>
  </>
);
export default ModelConfirm;
